//#region src/simphony_check_name_field.ts
let SimphonyCheckNameField = /* @__PURE__ */ function(SimphonyCheckNameField) {
	SimphonyCheckNameField[SimphonyCheckNameField["None"] = 0] = "None";
	SimphonyCheckNameField[SimphonyCheckNameField["FirstNameTemplate"] = 1] = "FirstNameTemplate";
	SimphonyCheckNameField[SimphonyCheckNameField["LastNameTemplate"] = 2] = "LastNameTemplate";
	SimphonyCheckNameField[SimphonyCheckNameField["TableNumber"] = 3] = "TableNumber";
	return SimphonyCheckNameField;
}({});
//#endregion
export { SimphonyCheckNameField };

//# sourceMappingURL=simphony_check_name_field.js.map